import {Mesh,Vector3,Matrix3,Raycaster,type Object3D} from 'three';
import type {Entity} from './protocol';
import {Quaternion} from 'three';
import {contentPlacementSchema,type ContentPlacement} from './service-contract/content-use';

export const INVENTORY_PROP_MIME='application/x-offworld-prop';
const normalMatrix=new Matrix3();

function visible(node:Object3D):boolean{for(let current:Object3D|null=node;current;current=current.parent)if(!current.visible)return false;return true;}
export function placementSurface(ray:Raycaster,roots:Object3D[]):Vector3|null{
  for(const root of roots)root.updateWorldMatrix(true,true);
  const hit=ray.intersectObjects(roots,true).find(hit=>hit.object instanceof Mesh&&visible(hit.object));
  if(!hit?.face)return null;
  const normal=hit.face.normal.clone().applyNormalMatrix(normalMatrix.getNormalMatrix(hit.object.matrixWorld));
  if(normal.y<.5)return null;
  return hit.point;
}
export function placementAt(point:Vector3|null):ContentPlacement|null{
  if(!point)return null;
  const parsed=contentPlacementSchema.safeParse({point:point.toArray().map(n=>String(Number(n.toFixed(6))))});return parsed.success?parsed.data:null;
}
/** Try nearby forward-facing surfaces, never silently fall back to the world origin. */
export function forwardPlacement(self:Entity|undefined,roots:Object3D[],cameraPosition:Vector3):ContentPlacement|null{
  if(!self)return null;
  const forward=new Vector3(0,0,1).applyQuaternion(new Quaternion(...self.rotation));forward.y=0;forward.normalize();
  for(const distance of [2,1.25,.75]){
    const x=self.position.x+forward.x*distance,z=self.position.z+forward.z*distance;
    const point=placementSurface(new Raycaster(new Vector3(x,10,z),new Vector3(0,-1,0)),roots);
    const placement=placementAt(point);if(!point||!placement)continue;
    const direction=point.clone().sub(cameraPosition),ray=new Raycaster(cameraPosition,direction.clone().normalize(),0,direction.length()-.02);
    if(ray.intersectObjects(roots,true).some(hit=>hit.object instanceof Mesh&&visible(hit.object)))continue;
    return placement;
  }
  return null;
}
